import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const TRANSITIONS = [
  { value: "fade", label: "Fondu" },
  { value: "cross-dissolve", label: "Fondu enchaîné" },
  { value: "slide-left", label: "Glissement ← Gauche" },
  { value: "slide-right", label: "Glissement → Droite" },
  { value: "zoom-in", label: "Zoom avant" },
  { value: "zoom-out", label: "Zoom arrière" },
  { value: "ken-burns", label: "Ken Burns (panoramique)" },
];

export const ASPECT_RATIOS = [
  { value: "16:9", label: "16:9 — Paysage", pad: "56.25%" },
  { value: "32:9", label: "32:9 — Bandeau large", pad: "28.125%" },
  { value: "4:3", label: "4:3 — Classique", pad: "75%" },
  { value: "1:1", label: "1:1 — Carré", pad: "100%" },
  { value: "9:16", label: "9:16 — Vertical", pad: "177%" },
];

export const indexById = (arr) => Object.fromEntries((arr || []).map((x) => [x.id, x]));

// Refresh embedded poster snapshots in banner slides from the latest posters (live update)
export const refreshPosterSlides = (images, postersById) =>
  (images || []).map((img) =>
    img.type === "poster" && img.poster_data && postersById[img.poster_data.id]
      ? { ...img, poster_data: postersById[img.poster_data.id] }
      : img
  );
